import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import BrandDetailsCustomProductsModel from "@sunSource/Store/Data/BrandDetailsCustomProducts/BrandDetailsCustomProductsState";

export interface GetProductIdsByBrandId extends ApiParameter {
    brandId: string;
}

const customApiUrl = "/api/v2/PopularProducts/GetByBrand";


export function getBrandDetailsProducts(parameter: GetProductIdsByBrandId) {
    return get<BrandDetailsCustomProductsModel>(`${customApiUrl}`, parameter);
}